import axios from 'axios';
import { getAuthToken } from '../utils/auth';
import { handleError } from '../utils/errorHandler';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT || 'https://apiqa.eventox.co/api',
  //baseURL : 'http://localhost:3006/api'
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isOrganizerProfile = requestUrl.includes('/organizer/profile');

    // 403: session expired for an authenticated user.
    // 404 on organizer/profile: account no longer exists — send them to login.
    // Public flows (e.g. signup "email already registered") must stay on-page.
    if (
      error.response &&
      getAuthToken() &&
      (status === 403 || (status === 404 && isOrganizerProfile))
    ) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    handleError(error);
    return Promise.reject(error);
  }
);

export default apiClient;
